import { DashboardIFrame } from "components/organisms/DashboardIFrame";

const Dashboard = () => {
  return <DashboardIFrame page="overview" />;
};

export { Dashboard };
